module.exports = __webpack_public_path__ + "toBride2-we-y-b.17c8e86b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-y-b.jpg
// module id = JRhl
// module chunks = 0